import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import ReportList from "../../../common/ReportList";
import Constants from "../../../../common/Constants";
// import { formatDateTime } from "../../../../common/Validations";
import moment from "moment";
import {
  currencyFormat,
  formatDate,
  formatDateTime,
} from "../../../../common/Validations";
import PrintStatusReports from "./PrintStatusReports";
import { useSelector } from "react-redux";
import CompleteJobcard from "./CompleteJobcard";
import ItemService from "../../../../services/commonService";
import { toastFunc } from "../../../../components/common/util";
import AckRecords from "./AckRecords";

const JobcardStatusReports = () => {
  const { t } = useTranslation();
  const [displayFilter, setDisplayFilter] = useState(false);
  const [selectedRows, setSelectedRows] = useState(false);
  const [tableDataStatus, setTableDataStatus] = useState(false);
  const [openViewJobcardCode, setOpenViewJobcardCode] = useState(false);
  const [openCompleteJobcardModel, setOpenCompleteJobcardModel] =
    useState(false);
  const [jobcard, setJobcard] = useState("");
  const [reloadFlag, setReloadFlag] = useState(false);
  const userData = useSelector((state) => state?.user); // User Details from Store

  const [ackData, setAckData] = useState([]);
  const [ackModel, setAckModal] = useState(false);

  const handleAckModelClose = () => {
    setAckData([]);
    setAckModal(false);
  };
  const handleAckRecords = async (row) => {
    let param = {
      url: "getAckRecordsBasedOnJobcard",
      page: Constants.TRANSACTION.ACKNOLEDGEJOBCARD.name,
      jobcard: row.jobcard,
    };
    try {
      const item = await ItemService.getAckRecordsBasedOnJobcard(param);
      if (item?.status === 200) {
        if (item?.data.length > 0) {
          setAckData(item?.data);
          setAckModal(true);
        }
      } else {
        console.log(">> Error: Loading getApplicationMaster");
      }
    } catch (error) {
      console.error("Error in handleStartStopSuccess:", error);
      toastFunc(
        Constants.MASTER.TOAST.error,
        t("msg_trasaction.msg_teamlead_acknowledge.error_occurred"),
        4000,
      );
    }
  };

  const columnsData = [
    userData?.data?.category === Constants.MASTER.USERS.ADMIN && {
      name: t("Actions"),
      selector: (row) => row.jobcard,
      sortable: true,
      width: "130px",
      cell: (row) =>
        (row.jobcardStatus === "Open" && row.quantityPerJobCard > 0) ||
        ((row.jobcardStatus === "Acknowledged" ||
          row.jobcardStatus === "Open" ||
          row.jobcardStatus === "Stopped") &&
          Number(row.quantityPerJobCard) === 0) ? (
          <Button
            variant="outline-primary"
            onClick={() => handleCompleteJobcard(row.jobcard)}
          >
            Complete
          </Button>
        ) : (
          <span className="bg-table-status bg-table-new-status">-</span>
        ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_jobcard"),
      selector: (row) => row.jobcard,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <>
          <span
            className={`bg-table-status ${row.quantityPerJobCard === 0 ? "bg-table-dark-danger-status" : "bg-table-new-status"}`}
          >
            {row.jobcard}
          </span>
        </>
      ),
      conditionalCellStyles: [
        {
          when: (row) => true, // apply to all rows
          style: {
            position: "sticky",
            left: "0px",
            background: "#fff",
            zIndex: 2,
            boxShadow: "2px 0 5px -2px #ddd",
          },
        },
      ],
    },
    {
      name: "Wire Trace Number",
      selector: (row) => row.materialTraceNumber,
      sortable: true,
      width: "210px",
      cell: (row) => row.materialTraceNumber || "-",
    },
    {
      name: "Ack Details",
      cell: (row) => (
        <div style={{ width: "100%", textAlign: "center" }}>
          <button className="btnTable" onClick={() => handleAckRecords(row)}>
            Ack Records
          </button>
        </div>
      ),
      width: "150px",
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_size"),
      selector: (row) => row.sizeCode,
      sortable: true,
      width: "190px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.sizeCode} </p>
          <p className="m-0 p-0 ">{row.sizeName} </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_priority"),
      selector: (row) => row.priority,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <>
          {row.priority === "urgent" ? (
            <span className="bg-table-status bg-table-danger-status">
              {t("msg_overview.urgent")}
            </span>
          ) : row.priority === "regular" ? (
            <span className="bg-table-status bg-table-info-status">
              <strong>{t("msg_overview.regular")}</strong>
            </span>
          ) : (
            <>{row.priority}</>
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_customer"),
      selector: (row) => row.customerName,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.customerName}</p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.req_date"),
      selector: (row) => row.requiredDate,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <span>
          <p className="m-0 p-0 pt-1">{formatDate(row.requiredDate)} </p>
        </span>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_plan"),
      selector: (row) => row.plan,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{moment(row.plan).format("MMM-YYYY")}</p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_planType"),
      selector: (row) => row.planType,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.planType}</p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_quantity"),
      selector: (row) => row.batchTotalQtyDozen,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <>
          <span
            className={`bg-table-status ${row.quantityPerJobCard === 0 ? "bg-table-dark-danger-status" : "bg-table-text-status"}`}
          >
            {row.originalQuantityPerJobCard} / {row.quantityPerJobCard}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_jobcard_status"),
      selector: (row) => row.jobcardStatus,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <>
          {row.jobcardStatus === "Inprogress" ? (
            <span className="bg-table-status bg-table-progress-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Open" ? (
            <span className="bg-table-status bg-table-new-status">
              {/* {row.jobcardStatus} */}
              NOT Acknowledged
            </span>
          ) : row.jobcardStatus === "Stopped" ? (
            <span className="bg-table-status bg-table-danger-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Acknowledged" ? (
            <span className="bg-table-status bg-table-success-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Closed" ? (
            <span className="bg-table-status bg-table-info-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Complete" ? (
            <span
              className={`bg-table-status ${row.quantityPerJobCard === 0 ? "bg-table-dark-danger-status" : "bg-table-documentNumber-status"}`}
            >
              {row.jobcardStatus}
            </span>
          ) : (
            <>{row.jobcardStatus}</>
          )}
        </>
      ),
    },
    {
      name: t("msg_trasaction.msg_generatejobcard.completedData"),
      selector: (row) => row.createdDateFromOC,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">
            {formatDateTime(row.createdDateFromOC)}
          </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_fromDepartment"),
      selector: (row) => row.fromDeptCode,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <>
          {row.fromDeptCode ? (
            <span className="bg-table-status bg-table-first-status">
              {row.fromDeptCode} - {row.fromDeptName}
            </span>
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_toDepartment"),
      selector: (row) => row.toDeptCode,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-second-status">
            {row.toDeptCode} - {row.toDeptName}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_toMachine"),
      selector: (row) => row.toMachineCode,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <>
          {row.toMachineCode ? (
            <span className="bg-table-status bg-table-second-status">
              {row.toMachineCode} - {row.toMachineName}
            </span>
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_teamlead"),
      selector: (row) => row.loginUserId,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">
            {row.loginUserId}- {row.loginUserName}
          </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_action"),
      selector: (row) => row.createdDate,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{formatDateTime(row.createdDate)}</p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_operator"),
      selector: (row) => row.loginUserId,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">
            {row.operatorUserId}- {row.operatorUserName}
          </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_action"),
      selector: (row) => row.operatorcreatedDate,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">
            {formatDateTime(row.operatorcreatedDate)}
          </p>
        </div>
      ),
    },
    // {
    //   name: t("msg_reports.msg_jobstatus_report.view_verified_checklist"),
    //   selector: (row) => row.verifiedCheckListData,
    //   cell: (row) => (
    //     <Button
    //       variant="outline-primary"
    //       // onClick={() => handleViewChecklist(row.verifiedCheckListData)}
    //     >
    //       {"View Checklist"}
    //     </Button>
    //   ),
    //   center: true,
    //   width: "250px",
    // },
  ];

  const handleSelectedRowsChange = ({ selectedRows }) => {
    setSelectedRows(selectedRows);
  };
  const handleTableDataStatus = (data) => {
    setTableDataStatus(data);
  };
  const handlePrintClick = () => {
    if (selectedRows) {
      setOpenViewJobcardCode(true);
    }
  };
  const handleRefreshClick = () => {
    setTableDataStatus([]);
    setReloadFlag(true);

    setTimeout(() => {
      setReloadFlag(false);
    }, 1000);
  }
  const resetJobcardModal = () => {
    setOpenViewJobcardCode(false);
  };

  const resetRemarksModal = () => {
    setOpenCompleteJobcardModel(false);
  };

  const handleCompleteJobcard = (jobcard) => {
    setJobcard(jobcard);
    setOpenCompleteJobcardModel(true);
  };

  const setCompleteRemarks = async (value) => {
    let param = {};
    param.url = "updateJobcardCompleteRemarks";
    param.page = Constants.TRANSACTION.GENERATEJOBCARD.name;
    param.jobcard = jobcard;
    param.remarks = value;
    param.remarksStatus = "COMPLETE-REMARKS";
    if (jobcard) {
      await ItemService.updateJobcardCompleteRemarks(param).then((item) => {
        // console.log(">> item! getApplicationMaster", item);
        if (item?.status === 200) {
          toastFunc(
            Constants.MASTER.TOAST.success,
            "Jobcard Completed Successfully",
            2000,
          );
          setOpenCompleteJobcardModel(false);
          setReloadFlag(true);
        } else {
          console.log(">> Error: In updating Remarks");
        }
      });
    }
  };

  return (
    <main className="generatejobcard main" id="main">
      <Row className="justify-center subContent">
        <Col xs={8} md={8} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">
              {t("msg_reports.msg_jobstatus_report.jobstatus_report_title")}
            </h2>
            <p className="subText">
              {t("msg_reports.msg_jobstatus_report.details_page")}
            </p>
          </div>
        </Col>
        <Col xs={4} md={4} className="leftSide">
          <Button
            type="button"
            variant="primary"
            size="lg"
            className="btn btn-primary float-right searchFilter-btn"
            onClick={() => setDisplayFilter(!displayFilter)}
          >
            <i className="bi bi-filter"> </i>
          </Button>
          <Button
            variant="primary"
            className="float-right mr-8"
            onClick={handlePrintClick}
          >
            {"PRINT"}
          </Button>{" "}
           <Button
            variant="btn btn-warning"
            className="float-right mr-8"
            onClick={handleRefreshClick}
          >
            <i className="bi bi-arrow-clockwise"></i>
          </Button>{" "}
        </Col>
        <hr />
      </Row>

      <div className="jobcard-status-summary mb-8">
        <div className="status-card all">
          <span className="count">
            {currencyFormat(tableDataStatus?.totalCount) || 0}
          </span>
          <span className="label">Total</span>
        </div>

        <div className="status-card inprogress">
          <span className="count">
            {currencyFormat(tableDataStatus?.statusCounts?.Inprogress || 0)}
          </span>
          <span className="label">In Progress</span>
        </div>

        <div className="status-card open">
          <span className="count">
            {currencyFormat(tableDataStatus?.statusCounts?.Open || 0)}
          </span>
          <span className="label">Not Acknowledged</span>
        </div>

        <div className="status-card stopped">
          <span className="count">
            {currencyFormat(tableDataStatus?.statusCounts?.Stopped || 0)}
          </span>
          <span className="label">Stopped</span>
        </div>

        <div className="status-card ack">
          <span className="count">
            {currencyFormat(tableDataStatus?.statusCounts?.Acknowledged || 0)}
          </span>
          <span className="label">Acknowledged</span>
        </div>

        <div className="status-card complete">
          <span className="count">
            {currencyFormat(tableDataStatus?.statusCounts?.Complete || 0)}
          </span>
          <span className="label">Complete</span>
        </div>
      </div>
      <div>
        <ReportList
          selectableRows={true}
          reloadFlag={reloadFlag}
          columnsData={columnsData}
          displayProdStatusFilter={displayFilter}
          handleSelections={handleSelectedRowsChange}
          handleTableDataStatus={handleTableDataStatus}
          resetFilerBox={setDisplayFilter}
          pageName={t(
            "msg_reports.msg_jobstatus_report.jobstatus_report_title",
          )}
          pageURL={Constants.REPORTS.JOBCARDSTATUS.list}
          name={Constants.REPORTS.JOBCARDSTATUS.name}
        />
      </div>

      {openViewJobcardCode && (
        <PrintStatusReports
          selectedItems={selectedRows}
          show={openViewJobcardCode}
          onHide={() => {
            resetJobcardModal();
          }}
        ></PrintStatusReports>
      )}
      {openCompleteJobcardModel && (
        <CompleteJobcard
          completeFunction={setCompleteRemarks}
          show={openCompleteJobcardModel}
          jobcard={jobcard}
          onHide={() => {
            resetRemarksModal();
          }}
        ></CompleteJobcard>
      )}

      {ackModel && (
        <AckRecords
          rowsData={ackData}
          show={ackModel}
          onHide={handleAckModelClose}
          jobcard={jobcard}
        ></AckRecords>
      )}
    </main>
  );
};

export default JobcardStatusReports;
